angular
  .module('GlobalControllers')

  .directive('mAppLoading', [
    '$animate',
    function($animate) {
      // Return the directive configuration.
      return {
        link: link,
        restrict: 'C'
      };

      // I bind the JavaScript events to the scope.
      function link(scope, element, attributes) {
        // Due to the way AngularJS prevents animation during the bootstrap
        // of the application, we can't animate the top-level container; but,
        // since we added "ngAnimateChildren", we can animated the inner
        // container during this phase.
        // --
        // NOTE: Am using .eq(1) so that we don't animate the Style block.

        $animate
          .leave(element.children())
          .then(function cleanupAfterAnimation() {
            // Remove the root directive element.
            element.remove();

            // Clear the closed-over variable references.
            scope = element = attributes = null;
          });
      }
    }
  ])

  .directive('cfContainer', [
    '$compile',
    function($compile) {
      return {
        restrict: 'AC',
        replace: false,
        terminal: true,
        priority: 1001,
        link: function link(scope, element, attrs) {
          element.attr('flex', '80');
          element.attr('flex-xs', '100');
          element.attr('flex-sm', '90');

          element.removeAttr('cf-container');
          element.removeClass('cf-container');

          $compile(element)(scope);
        }
      };
    }
  ])

  .directive('cfFlexboxTest', function() {
    return {
      restrict: 'E',
      replace: true,
      template:
        "<div ng-if='::flexTest' id='warningFlex' class='text-center'>\
              <div>\
              <h1 class='md-title'>Nathan TOEIC<up>®</up></h1>\
              <h2>Votre navigateur n'est pas supporté, merci de le mettre à jour.</h2>\
              <a class='font-300' style='font-size:15px;' href='https://browsehappy.com'>En savoir plus</a>\
              <p><b>Nathan TOEIC<up>®</up></b> utilise les derniers standards du web pour vous offrir une expérience d'apprentissage inédite et s'excuse de la gêne occasionnée.</p>\
              <br><p><b>L'équipe Nathan TOEIC<up>®</up></b></p>\
              </div>\
              </div>",
      controller: [
        '$scope',
        function($scope) {
          $scope.flexTest = !(Modernizr.flexbox && Modernizr.flexwrap);
        }
      ]
    };
  })

  .directive('cfLogoInstitution', function() {
    return {
      restrict: 'E',
      template:
        '<div class="md-padding" ng-if="::main.me.institution">\
                <img ng-src="{{::main.me.institution.logo}}" class="img-responsive center-block" style="max-width:90%; width: 200px;">\
                <md-tooltip md-direction="top">{{\'logoInstitution.text\' | translate}} {{::main.me.institution.name}}</md-tooltip>\
              </div>'
    };
  })

  .directive('cfTeacherCaption', function() {
    return {
      restrict: 'E',
      templateUrl: '/ng1/www/modules/global/others/html/pro_caption.html'
    };
  })

  .directive('cfChips', function() {
    return {
      restrict: 'E',
      transclude: true,
      template:
        '<span class="grey-bg md-whiteframe-z1 md-body-1"><ng-transclude></ng-transclude></span>'
    };
  })

  .directive('cfExamName', [
    'exam',
    function(exam) {
      return {
        restrict: 'E',
        replace: true,
        template: `<span class="exam-name" ng-if="!examData.brandNameAsCertification">
        {{examData.shortName.text | uppercase}}<up ng-if="examData.shortName.trademark">®</up>
      </<span>`
      };
    }
  ])

  .directive('cfFooterLink', [
    function() {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: '/ng1/www/modules/global/others/html/footer-link.html'
      };
    }
  ])

  .directive('autoFocus', [
    '$timeout',
    function($timeout) {
      return {
        restrict: 'AC',
        link: function(_scope, _element) {
          $timeout(function() {
            _element[0].focus();
          }, 0);
        }
      };
    }
  ]);
